import { lazy } from 'react';

// project import
import { ContentLoad, MainLoad } from 'components/LoadScreen';
const MinimalLayout = MainLoad(lazy(() => import('layout/MinimalLayout')));

// render - login
const AuthLogin = ContentLoad(lazy(() => import('pages/authentication/Login')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: 'login',
            element: <AuthLogin />
        }
    ]
};

export default LoginRoutes;
